export default __webpack_public_path__ + "static/media/benifit-three-icon.ec726e32.svg";